<template>
    <fieldset class="order-details co-fieldset">
        <div class="co-fieldset-inner">
            <div class="od-inputs-row">
                <div class="scheduler-toggle-container">
                    <input
                        type="checkbox"
                        style="padding-right: 10px"
                        value="1"
                        v-model="schedulerEnabled"
                        name="scheduler-enabled"
                        id="scheduler-enabled"
                    />
                    &nbsp; Add automated orders
                </div>
                <div v-if="schedulerEnabled">
                    <div id="scheduler-details-block">
                        <div style="padding: 10px 0 0 26px">
                            <div class="scheduler-title">Schedule</div>
                        </div>
                        <input
                            type="hidden"
                            value="in preparation"
                            v-model="formState.scheduler.new_order_status"
                        />
                        <div class="grid scheduler-details-sub-block">
                            <div class="scheduler-input-container">
                                <div id="scheduler-recurrence-label">
                                    <div class="error-tooltip-container">
                                        <div class="error-tooltip">
                                            Please select scheduler recurrence
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <label class="create-form-label"
                                            >Picks files up:
                                        </label>
                                    </div>
                                    <div>
                                        <select
                                            name="scheduler[interval_hours]"
                                            class="order-input"
                                            id="scheduler-period"
                                            v-model="
                                                formState.scheduler
                                                    .interval_hours
                                            "
                                        >
                                            <option
                                                value=""
                                                selected
                                                style="color: #aaa"
                                            >
                                                Select Recurrence
                                            </option>
                                            <option value="1">Hourly</option>
                                            <option value="24">Daily</option>
                                            <option value="168">Weekly</option>
                                            <option value="730">Monthly</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="scheduler-input-container">
                                    <div>
                                        <label class="create-form-label"
                                            >At time:
                                        </label>
                                    </div>
                                    <VueCtkDateTimePicker
                                        v-model="
                                            formState.scheduler.pick_up_time
                                        "
                                        minuteInterval="30"
                                        format="hh:mm a"
                                        formatted="hh:mm a"
                                        :onlyTime="true"
                                        :noLabel="true"
                                        label="Select pick up time"
                                        :noHeader="true"
                                        :noClearButton="true"
                                        inputSize="sm"
                                        style="
                                            font-size: 19px;
                                            border-color: black;
                                            width: 175px !important;
                                            margin: 0;
                                        "
                                        color="#EF7720"
                                    />
                                </div>
                                <div
                                    style="
                                        font-size: 11px;
                                        padding-left: 4px;
                                        color: gray;
                                    "
                                >
                                    Times are EST
                                </div>
                            </div>
                            <div class="scheduler-input-container">
                                <div id="scheduler-date-start-label">
                                    <div class="error-tooltip-container">
                                        <div class="error-tooltip">
                                            Please select scheduler start date
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <label
                                        class="create-form-label"
                                        id="scheduler-date-start-label"
                                        >Start</label
                                    >
                                </div>
                                <div>
                                    <input
                                        class="order-input"
                                        autocomplete="off"
                                        v-model="formState.scheduler.started_at"
                                        placeholder="Select Date"
                                        type="date"
                                    />
                                </div>
                            </div>
                            <div>
                                <div id="scheduler-date-start-label">
                                    <div class="error-tooltip-container">
                                        <div class="error-tooltip">
                                            Please select scheduler start date
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <label
                                        class="create-form-label"
                                        id="scheduler-date-end-label"
                                        >End</label
                                    >
                                </div>
                                <div class="scheduler-end-container">
                                    <div>
                                        <input
                                            type="radio"
                                            value="none"
                                            class="scheduler-end-radio"
                                            v-model="schedulerEnds"
                                            checked
                                        />
                                        No end date
                                    </div>
                                    <div>
                                        <input
                                            type="radio"
                                            value="end_by_date"
                                            class="scheduler-end-radio"
                                            v-model="schedulerEnds"
                                        />
                                        End By
                                    </div>
                                    <div>
                                        <input
                                            v-if='schedulerEnds === "end_by_date"'
                                            style="margin-left: 5px;"
                                            class="order-input"
                                            v-model="endBy"
                                            type="date"
                                            placeholder="Select Date"
                                            autocomplete="off"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            class="scheduler-connector-container"
                            style="padding: 15px 25px"
                        >
                            <div
                                class="scheduler-title"
                                style="padding-bottom: 10px"
                            >
                                Action
                            </div>
                            <div
                                class="details-row scheduler-details-sub-block"
                                style="
                                    border: 1px solid #e4e4e4;
                                    padding: 25px;
                                    background: white;
                                "
                            >
                                <div
                                    class="scheduler-input-container"
                                    style="width: 175px"
                                >
                                    <div>
                                        <label class="create-form-label"
                                            >Cloud Service</label
                                        >
                                    </div>
                                    <select
                                        name="scheduler[connector_id]"
                                        class="order-input"
                                        id="scheduler-connector-picker"
                                    >
                                        <option
                                            selected
                                            disabled
                                            value="Google"
                                        >
                                            Google
                                        </option>
                                    </select>
                                </div>

                                <div class="scheduler-input-container">
                                    <div id="scheduler-source-folder-label">
                                        <div class="error-tooltip-container">
                                            <div class="error-tooltip">
                                                Please select scheduler source
                                                folder
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <label class="create-form-label"
                                            >Source Folder</label
                                        >
                                    </div>
                                    <button
                                        type="button"
                                        id="scheduler-source-folder-button"
                                        class="scheduler-folder-picker italics"
                                        @click="googleSourceFile"
                                    >
                                        {{
                                            formState.scheduler
                                                .source_folder_name ||
                                            "Select Source Folder"
                                        }}
                                    </button>
                                    <span style="margin-top: 3px">
                                        <input
                                            type="checkbox"
                                            id="pickup_from_subfolders"
                                            value="1"
                                            name="scheduler[pickup_from_subfolders]"
                                            v-model="
                                                formState.scheduler
                                                    .pickup_from_subfolders
                                            "
                                        />
                                        &nbsp;Include subfolders
                                    </span>
                                    <!-- Scheduler Folder Inputs-->
                                    <input
                                        type="hidden"
                                        v-model="
                                            formState.scheduler.source_folder_id
                                        "
                                        id="scheduler-source-folder-id"
                                    />
                                    <input
                                        type="hidden"
                                        v-model="
                                            formState.scheduler
                                                .source_folder_name
                                        "
                                        id="scheduler-source-folder-name"
                                    />
                                </div>

                                <div class="scheduler-input-container">
                                    <div id="scheduler-target-folder-label">
                                        <div class="error-tooltip-container">
                                            <div class="error-tooltip">
                                                Please select scheduler target
                                                folder
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <label class="create-form-label"
                                            >Target Folder</label
                                        >
                                    </div>
                                    <button
                                        type="button"
                                        id="scheduler-target-folder-button"
                                        class="scheduler-folder-picker italics"
                                        @click="googleTargetFile"
                                    >
                                        {{
                                            formState.scheduler
                                                .target_folder_name ||
                                            "Select Target Folder"
                                        }}
                                    </button>
                                    <!-- Scheduler Folder Inputs-->
                                    <input
                                        type="hidden"
                                        v-model="
                                            formState.scheduler.target_folder_id
                                        "
                                        id="scheduler-target-folder-id"
                                    />
                                    <input
                                        type="hidden"
                                        v-model="
                                            formState.scheduler
                                                .target_folder_name
                                        "
                                        id="scheduler-target-folder-name"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </fieldset>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import "./style.scss";
export default {
    name: "Budget",
    props: {},
    created() {
        gapi.load("picker");
    },
    methods: {
        ...mapMutations("CreateProgramStore", [
            "setSchedulerEnabled",
            "setSchedulerIntervalHours",
            "setSchedulerPickUpTime",
            "setSchedulerNewOrderStatus",
            "setSchedulerStartedAt",
            "setSchedulerEnd",
            "setSchedulerEndsAt",
            "setSchedulerConnectorId",
            "setSchedulerSourceFolderId",
            "setSchedulerSourceFolderName",
            "setSchedulerTargetFolderId",
            "setSchedulerTargetFolderName",
            "setSchedulerPickupFromSubFolders",
        ]),

        googleSourceFile() {
            if (backend.onBehalfUser) {
                popupAlert(
                    'For security reasons, you cannot view a user\'s drive while in "On Behalf" mode',
                    "Oops!"
                );
                return;
            }

            const callback = (data) => {
                if (data.action != google.picker.Action.PICKED) {
                    return false;
                }

                let folder = data.docs[0]["name"];
                let id = data.docs[0]["id"];

                this.setSchedulerSourceFolderName(truncateString(folder, 35));
                this.setSchedulerSourceFolderId(id);
            };

            const vm = this;

            $.ajax({
                url: "/connectors/google/refresh",
                method: "GET",
                success: function (data, vm) {
                    var docsView = new google.picker.DocsView(
                        google.picker.ViewId.DOCS
                    )
                        .setIncludeFolders(true)
                        .setOwnedByMe(true)
                        .setMimeTypes("application/vnd.google-apps.folder")
                        .setSelectFolderEnabled(true);

                    const picker = new google.picker.PickerBuilder()
                        .setTitle(`Select Source Folder`)
                        .addView(docsView)
                        .setOAuthToken(data.token)
                        .setCallback(callback)
                        .enableFeature(google.picker.Feature.SUPPORT_DRIVES)

                        .build();

                    picker.setVisible(true);
                },
            });
        },
        googleTargetFile() {
            if (backend.onBehalfUser) {
                popupAlert(
                    'For security reasons, you cannot view a user\'s drive while in "On Behalf" mode',
                    "Oops!"
                );
                return;
            }

            const callback = (data) => {
                if (data.action != google.picker.Action.PICKED) {
                    return false;
                }

                let folder = data.docs[0]["name"];
                let id = data.docs[0]["id"];

                this.setSchedulerTargetFolderName(truncateString(folder, 35));
                this.setSchedulerTargetFolderId(id);
            };

            const vm = this;

            $.ajax({
                url: "/connectors/google/refresh",
                method: "GET",
                success: function (data, vm) {
                    var docsView = new google.picker.DocsView(
                        google.picker.ViewId.DOCS
                    )
                        .setIncludeFolders(true)
                        .setOwnedByMe(true)
                        .setMimeTypes("application/vnd.google-apps.folder")
                        .setSelectFolderEnabled(true);

                    const picker = new google.picker.PickerBuilder()
                        .setTitle(`Select Source Folder`)
                        .addView(docsView)
                        .setOAuthToken(data.token)
                        .setCallback(callback)
                        .enableFeature(google.picker.Feature.SUPPORT_DRIVES)

                        .build();

                    picker.setVisible(true);
                },
            });
        },
    },
    computed: {
        ...mapState({
            formState: (state) => state.CreateProgramStore,
        }),
        ...mapGetters("AuthStore", ["isAdminUser"]),
        schedulerEnabled: {
            get() {
                return this.formState.scheduler_enabled;
            },
            set(value) {
                this.setSchedulerEnabled(value);
            },
        },
        includeSubfolders: {
            get() {
                return this.formState.pickup_from_subfolders;
            },
            set(value) {
                this.setSchedulerPickupFromSubFolders(value);
            },
        },
        schedulerEnds: {
            get() {
                return this.formState.scheduler.end;
            },
            set(value) {
                this.setSchedulerEnd(value);
            },
        },
        endBy: {
            get() {
                return this.formState.scheduler.ends_at;
            },
            set(value) {
                this.setSchedulerEndsAt(value);
            },
        },
    },
};
</script>
